import { render, staticRenderFns } from "./OrderProductTableForMultipleProducts.vue?vue&type=template&id=e4ae09c2&scoped=true&"
import script from "./OrderProductTableForMultipleProducts.vue?vue&type=script&lang=js&"
export * from "./OrderProductTableForMultipleProducts.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductTableForMultipleProducts.vue?vue&type=style&index=0&id=e4ae09c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ae09c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VDataTable,VSelect,VSimpleCheckbox})
